module.exports = __webpack_public_path__ + "img/6.cf33dec6.png";